import type {
  TBlueTable,
  TBlueAny,
  TBlueStr,
  TBlueObj,
  TBlueNum,
  BlueItem,
} from "@app/types/insider";
import { appJobs } from "@app/statefx/schema/app-jobs.def";
// /// the INDEXEDDB schema builder
import { applog } from "@app/statefx/schema/app-log.def";
import { appRepo, whoamiRepo } from "@app/statefx/schema/app.def";
import { appProcess } from "@app/statefx/schema/appProcess.def";
import { contactlist } from "@app/statefx/schema/contactlist.def";
import {
  contractors_anaf,
  contractors_cff,
  contractors_temp,
  iso3166_2,
  isoNewCities,
} from "@app/statefx/schema/contractors.def";
import {
  currencies,
  currencyRates,
  currencyRatesCustom,
} from "@app/statefx/schema/currency";
import { chooserRepo } from "@app/statefx/schema/drawer.def";
// import { jgLogin } from '@app/statefx/schema/jgLogin.def';
import { fiscalBooks } from "@app/statefx/schema/fiscalBooks.def";
import {
  fileSysContent,
  fileSysHead,
  fileSysLocalDisk,
  fsDirTree,
  fsRepo,
} from "@app/statefx/schema/fs.def";
import { invoiceCollection } from "@app/statefx/schema/invoiceCollect.def";
import {
  invoiceFiscal,
  OAuth2Status,
  receiptFiscal,
} from "@app/statefx/schema/invoiceData.def";
import { invoicetrackrepo } from "@app/statefx/schema/invoicetrack.def";
import { listModels } from "@app/statefx/schema/lists.def";
import { dialogs, notifyRepo } from "@app/statefx/schema/notify.def";
import {
  invoiceIssuer,
  issuerBankAccounts,
  profileGroup,
  profiles,
} from "@app/statefx/schema/profile.def";
import {
  SPVInvoiceRaw,
  SPVMessageKeys,
  SPVMessages,
  SPVMessageUserState,
} from "@app/statefx/schema/spv.def";
import {
  uiAllotment,
  uiAllotmentCollapsed,
} from "@app/statefx/schema/uiAllotment.def";
import { uiContractorsEditing } from "@app/statefx/schema/uiContractorsEditing.def";
import { uiFiscalBooks } from "@app/statefx/schema/uiFiscalBooks.def";
import { uiJGBrowserHeader } from "@app/statefx/schema/uiHeader.def";
import { uiInvoiceEditing } from "@app/statefx/schema/uiInvoiceEditing.def";
import {
  uiCollectionCurrent,
  uiInvoiceCurrent,
  uiInvoiceOverall,
} from "@app/statefx/schema/uiInvoiceMain.def";
import {
  persitorGuardian,
  uiPersistInvoiceGrid,
  uiPersistSpvList,
} from "@app/statefx/schema/uiPersistGrid.def";
import { uiSpvGrid, uiSpvMain } from "@app/statefx/schema/uiSpvMain.def";

export const schemaB = {
  applog,
  appJobs,
  appProcess,
  appRepo,
  chooserRepo,
  contactlist,
  contractors_anaf,
  contractors_cff,
  contractors_temp,
  currencies,
  currencyRates,
  currencyRatesCustom,
  dialogs,
  fileSysContent,
  fileSysHead,
  fileSysLocalDisk,
  fiscalBooks,
  fsDirTree,
  fsRepo,
  invoiceCollection,
  invoiceFiscal,
  invoiceIssuer,
  invoicetrackrepo,
  iso3166_2,
  isoNewCities,
  issuerBankAccounts,
  listModels,
  notifyRepo,
  OAuth2Status,
  persitorGuardian,
  profileGroup,
  profiles,
  receiptFiscal,
  SPVInvoiceRaw,
  SPVMessageKeys,
  SPVMessages,
  SPVMessageUserState,
  uiAllotment,
  uiAllotmentCollapsed,
  uiCollectionCurrent,
  uiContractorsEditing,
  uiFiscalBooks,
  uiInvoiceCurrent,
  uiInvoiceEditing,
  uiInvoiceOverall,
  uiJGBrowserHeader,
  uiPersistInvoiceGrid,
  uiPersistSpvList,
  uiSpvGrid,
  uiSpvMain,
  whoamiRepo,
};

// export const schemaB = schemaBx.reduce<Record<BlueItem['name'], BlueItem>>((acc, sb) => {
//   acc[sb.name] = sb;
//   return acc;
// }, {});

export type TSChemaBlue = typeof schemaB;
